import React from 'react';

/**
 * Rotating arrow: on .arrow-trigger parent hover, the icon rotates clockwise
 * 45° — from 1 o'clock (↗) to 3 o'clock (→).
 *
 * Icon        — Lucide icon component (use ArrowUpRight for the 1→3 effect)
 * iconClass   — size + color classes (e.g. "h-5 w-5 text-[#D64545]")
 * wrapClass   — extra layout classes on the icon (e.g. "mt-1 shrink-0")
 * strokeWidth — forwarded to the icon
 */
const SlideArrow = ({ Icon, iconClass = '', wrapClass = '', strokeWidth }) => (
  <Icon
    className={`rotate-arrow ${iconClass} ${wrapClass}`.trim()}
    strokeWidth={strokeWidth}
    aria-hidden
  />
);

export default SlideArrow;
